import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import confetti from 'canvas-confetti';
import { filter, Subscription } from 'rxjs';
import { MyDiscountService } from 'src/app/shared/services/my-discount.service';
import { APIFactoryEndPoints } from 'src/app/common/apifactory-end-points';
import { DiscountProduct, RedeemedDetails } from 'src/app/shared/models/discount-product';
import { GoogleCustomer } from 'src/app/shared/models/googlecustomer';
import { LocalStorageService } from 'src/app/common/LocalStorageService';
import { SelectedRewardProductDto } from 'src/app/shared/models/selected-reward-product-dto';
import { ToastService } from 'src/app/shared/services/toastr.service';
import { WebSocketService } from 'src/app/common/WebSocketService';
import { Router } from '@angular/router';
import { MyCouponService } from 'src/app/shared/services/my-coupon.service';
import { AgreedTermsDialogComponent } from '../agreed-terms-dialog/agreed-terms-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';

@Component({
  selector: 'app-my-discount',
  templateUrl: './my-discount.component.html',
  styleUrls: ['./my-discount.component.scss']
})
export class MyDiscountComponent implements OnInit, AfterViewInit {

  productList: any[] = [];
  activeTab: string = 'home';
  activeSort: string = '';
  homeCount: number = 0;
  redeemedCount: number = 0;
  showLuckModal = false;
  wonDiscount = 0;
  qrData = '';
  selectedRewardType: 'money' | 'product' | null = null;
  // selectedRewardProduct: RewardOption | null = null;
  selectedRewardProduct: SelectedRewardProductDto;
  isShuffling = false;
  orgDiscountProducts: DiscountProduct[] = [];
  discountProducts: DiscountProduct[] = [];
  googleCustomer: GoogleCustomer;
  showRewardDetailsModal = false;
  redeemedDetails: RedeemedDetails;
  isAgreedTerms: boolean = false;
  wait: boolean = false;
  redeemedProducts: any[] = [];
  displyProducts: boolean = false;
  displayRedeemed: boolean = false;

  //Subscription
  private getActiveDiscountProductSubscription: Subscription;
  private getActiveOffersSubscription: Subscription;
  private onRatingSubscription: Subscription;
  private getCouponTermsAgreedSubscription: Subscription;

  constructor(
    private myDiscountService: MyDiscountService,
    private apiFactory: APIFactoryEndPoints,
    private localStorage: LocalStorageService,
    private toastService: ToastService,
    private webSocketService: WebSocketService,
    private router: Router,
    public dialog: MatDialog,
    private myCouponService: MyCouponService,
  ) { }

  ngOnInit(): void {
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    if (this.googleCustomer == null) {
      this.router.navigate(["/login", "qr-spinNWin"]);
      return;
    }
    // this.getActiveDiscountProducts('home');
    this.subscribeToNotifications('my-discount-' + this.googleCustomer.refNo);
    this.getCouponTermsAgreed();
  }

  getCouponTermsAgreed() {
    this.getCouponTermsAgreedSubscription = this.myCouponService.getCouponTermsAgreed(this.apiFactory.getCouponTermsAgreed, this.googleCustomer.email, 'Spin n Win')
      .subscribe((data: boolean) => {
        this.isAgreedTerms = data;
        if (!data) {
          this.openPrivacyPolicyDialog();
        } else {
          this.filterCoupons('home');
        }
      });
  }

  getActiveDiscountProducts(filterType: string) {
    this.wait = false;

    this.getActiveDiscountProductSubscription = this.myDiscountService.getActiveDiscountProducts(this.apiFactory.getActiveDiscountProducts, this.googleCustomer.refNo)
      .subscribe((data: DiscountProduct[]) => {
        this.wait = true;
        if (data) {
          this.orgDiscountProducts = data;
          this.discountProducts = this.orgDiscountProducts.filter(
            discountProduct => discountProduct.status === null || discountProduct.status === 'Generated'
          );
          this.homeCount = this.orgDiscountProducts.filter(discountProduct => discountProduct.status === null || discountProduct.status === 'Generated').length;
        }
      });
    this.getRedeemedDiscountProducts();
  }

  getRedeemedDiscountProducts() {
    this.getActiveDiscountProductSubscription = this.myDiscountService.getRedeemedDiscountProducts(this.apiFactory.getRedeemedDiscountProducts, this.googleCustomer.refNo)
      .subscribe((data: any[]) => {
        this.wait = true;
        if (data) {
          this.redeemedProducts = data;
          this.redeemedProducts = this.redeemedProducts
            .map(product => {
              if (product) {
                product.rating = product.rating || 0;
                product.isRated = product.rating > 0;
              }
              return product;
            });
        }
        this.redeemedCount = this.redeemedProducts.length;
      });
  }

  filterCoupons(tab: string) {
    this.activeTab = tab;
    this.activeSort = '';
    if (tab === 'home') {
      this.displyProducts = true;
      this.displayRedeemed = false;
      this.getActiveDiscountProducts('home');

    } else {
      this.displyProducts = false;
      this.displayRedeemed = true;

      // this.discountProducts = this.orgDiscountProducts
      //   .filter(product => product.status === 'Redeemed')
      //   .map(product => {
      //     if (product.redeemedDetails) {
      //       product.redeemedDetails.rating = product.redeemedDetails.rating || 0;
      //       product.redeemedDetails.isRated = product.redeemedDetails.rating > 0;
      //     }
      //     return product;
      //   });
      this.getRedeemedDiscountProducts();
    }
  }

  tryMyLuck(product: DiscountProduct) {
    this.selectedRewardType = null;
    this.qrData = '';
    this.showLuckModal = true;

    // Start loading (shuffling logic depends on status)
    this.isShuffling = product.status !== 'Generated';

    this.getActiveOffersSubscription = this.myDiscountService.getActiveOffers(this.apiFactory.getActiveOffersForDiscountProducts, this.googleCustomer.refNo, product.productCode, product.festivalDiscountSetupCode)
      .subscribe((data: SelectedRewardProductDto) => {
        if (data) {
          this.selectedRewardProduct = data;
          this.selectedRewardProduct.status = product.status;

          if (product.status === 'Generated') {
            // Skip shuffle delay, show reward immediately
            this.wonDiscount = data.value;
            this.isShuffling = false;
            this.launchCelebration();
          } else {
            // Apply shuffle delay and then show reward
            setTimeout(() => {
              this.wonDiscount = data.value;
              this.isShuffling = false;
              this.launchCelebration();
            }, 2000);
          }
        }
      });
  }

  onRewardTypeChange(type: 'money' | 'product') {
    this.selectedRewardType = type;

    if (this.selectedRewardProduct) {
      const dynamicCode = this.selectedRewardProduct.dynamicCode;
      this.qrData =
        type === 'money'
          ? `Code=${dynamicCode}&Type=Price`
          : `Code=${dynamicCode}&Type=Product`;
    }
  }

  closeModal(type: string) {
    this.showLuckModal = false;
    this.selectedRewardType = null;
    this.qrData = '';
    this.filterCoupons(type);
    if (type === 'redeemed') {
      this.getActiveDiscountProducts('home');
    }
  }

  showRewardDetails(product: DiscountProduct) {
    this.showRewardDetailsModal = true;
    this.redeemedDetails = product.redeemedDetails;
    console.log(this.redeemedDetails);
    // Ensure rating is set and determine if rating has been submitted
    this.redeemedDetails.rating = this.redeemedDetails.rating || 0; // Default to 0 if no rating
    this.redeemedDetails.isRated = this.redeemedDetails.rating > 0; // If rating exists, set isRated to true

  }

  closeRewardDetails() {
    this.showRewardDetailsModal = false;
    this.redeemedDetails = null;
  }

  submitRating(details: any) {
    console.log('Rating submitted:', details);
    if (details.isRated) {
      return; // Prevent multiple submissions
    }
    // Add your logic to handle the rating submission
    this.onRatingSubscription = this.myDiscountService.saveRating(this.apiFactory.discountRatingInsert, details.refNo, details.rating)
      .subscribe((data) => {
        details.isRated = true;
        this.toastService.showSuccessToast('Rating submitted successfully!');
      });
  }


  @ViewChild('confettiCanvas', { static: false }) confettiCanvas!: ElementRef;

  launchCelebration() {
    if (this.confettiCanvas) {
      const myConfetti = confetti.create(this.confettiCanvas.nativeElement, {
        resize: true,
        useWorker: true
      });

      myConfetti({
        particleCount: 150,
        spread: 100,
        origin: { y: 0.6 }
      });
    }
  }

  openPrivacyPolicyDialog() {
    const dialogRef = this.dialog.open(AgreedTermsDialogComponent, {
      width: "700px",
      height: "650px",
      data: "spinNWinPolicy",
      autoFocus: false,
      panelClass: ["animate__animated", "animate__slideInUp"],
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log(result);
      this.isAgreedTerms = result?.isClose;
      console.log(this.isAgreedTerms);
      this.wait = true;
      if (this.isAgreedTerms) {
        this.getActiveDiscountProducts('home');
      }
    });
  }

  subscribeToNotifications(id: any) {
    let stompClient = this.webSocketService.connect(); // Get the Stomp client
    stompClient.onConnect = (frame) => {
      console.log("Connected: " + frame);
      stompClient.subscribe(`/topic/${id}/notification`, (message) => {
        // alert(message.body);
        this.toastService.showSuccessToast(message.body);
        this.closeModal('redeemed');
      });
    };

    stompClient.onStompError = (frame) => {
      console.error("STOMP Error:", frame);
    };

    stompClient.activate(); // Activate the WebSocket connection
  }

  onFloatingButtonClick(type: string) {
    if (type === 'Trending Now') {
      this.router.navigate(['/products'], {
        queryParams: {
          category: 'Group',
          code: '169,112,1,161,151,139',
        }
      });
    } else if (type === 'Best Deals') {
      this.router.navigate(['/products'], {
        queryParams: {
          category: 'Group',
          code: '165,51,161,112',
          filter: 'offers'
        }
      });
    }
  }

  @ViewChild('offerText') offerText!: ElementRef;
  ngAfterViewInit() {
    const messages = [
      " Trending Products! View Now",
    ];

    const element = this.offerText?.nativeElement;
    let messageIndex = 0;
    let charIndex = 0;
    let isDeleting = false;

    const typeEffect = () => {
      if (!element) return;

      const currentMessage = messages[messageIndex];
      const visibleText = currentMessage.substring(0, charIndex);
      element.textContent = visibleText;

      let typingSpeed = isDeleting ? 50 : 100;

      if (!isDeleting && charIndex === currentMessage.length) {
        setTimeout(() => {
          isDeleting = true;
          typeEffect();
        }, 1500);
      } else if (isDeleting && charIndex === 0) {
        isDeleting = false;
        messageIndex = (messageIndex + 1) % messages.length;
        setTimeout(typeEffect, 300);
      } else {
        charIndex = isDeleting ? charIndex - 1 : charIndex + 1;
        setTimeout(typeEffect, typingSpeed);
      }
    };

    typeEffect();
  }


  infoDialogOpened = false;
  showBounce = true;

  openInfoDialog() {
    this.infoDialogOpened = true;
    this.showBounce = false; // stop bounce when opened

    const dialogRef = this.dialog.open(InfoDialogComponent, {
      width: '400px',
      panelClass: 'info-dialog-container'
    });

    dialogRef.afterClosed().subscribe(() => {
      this.infoDialogOpened = false;
      // optionally re-enable bounce after 2 seconds
      setTimeout(() => {
        this.showBounce = true;
      }, 2000);
    });
  }




  // this.productList = [
  //   { productName: 'Veg Puff', image: 'product/Veg Puff.webp', product_Code: 850, net_Sale_Price: 22 },
  //   { productName: 'Osmania Cookies', image: 'product/Osmania Cookies.webp', product_Code: 819, net_Sale_Price: 40 },
  //   { productName: 'Little Hearts', image: 'product/Little Hearts.webp', product_Code: 828, net_Sale_Price: 60 },
  //   { productName: 'Raagi Crackers', image: 'product/Raagi Crackers.webp', product_Code: 824, net_Sale_Price: 70 },
  // ];
  // rewardOptions: RewardOption[] = [
  //   { amount: 10, productName: 'Veg Puff', productImage: 'product/Veg Puff.webp', productCode: 850, net_Sale_Price: 22 },
  //   { amount: 20, productName: 'Osmania Cookies', productImage: 'product/Osmania Cookies.webp', productCode: 819, net_Sale_Price: 40 },
  //   { amount: 30, productName: 'Little Hearts', productImage: 'product/Little Hearts.webp', productCode: 828, net_Sale_Price: 60 },
  //   { amount: 40, productName: 'Raagi Crackers', productImage: 'product/Raagi Crackers.webp', productCode: 824, net_Sale_Price: 70 },
  // ];

}